import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  fields: string[];
  translatedMessage: string;
  isDialogOpen: boolean;
  isUpdating: boolean;
  isFetching: boolean
};

const initialState: StateInterface = {
  fields: [],
  translatedMessage: "",
  isDialogOpen: false,
  isUpdating: false,
  isFetching: false,
};

export const mailsReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_REQUEST:
      return {...state,
        isFetching: true
      };

    case Constants.PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_SUCCESS:
      return {...state,...action.payload,
        isFetching: false
      };

    case Constants.PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_FAILURE:
      return {...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
